import register from '../../../../global/js/registry';
export default register('o-flipcard', () => import(/* webpackMode: "lazy" */ './o-flipcard.controller'));
